import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';
import { ChevronDownIcon } from './Icons';

const LANGUAGES = [

    { code: 'ar', label: 'العربية (AR)' },
    { code: 'fr', label: 'Français (FR)' }
];

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        document.body.dir = lng === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = lng;
        setIsOpen(false);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const currentLang = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

    return (
        <div className="language-switcher-wrapper" ref={dropdownRef}>
            <button
                className={`language-selected-btn ${isOpen ? 'active' : ''}`}
                onClick={() => setIsOpen(!isOpen)}
                aria-haspopup="listbox"
                aria-expanded={isOpen}
            >
                <span className="lang-label">{currentLang.label}</span>
                <ChevronDownIcon className={`arrow-icon ${isOpen ? 'rotate' : ''}`} />
            </button>

            {isOpen && (
                <ul className="language-dropdown-list" role="listbox">
                    {LANGUAGES.map((lang) => (
                        <li
                            key={lang.code}
                            className={`language-option ${i18n.language === lang.code ? 'selected' : ''}`}
                            onClick={() => changeLanguage(lang.code)}
                            role="option"
                            aria-selected={i18n.language === lang.code}
                        >
                            {lang.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default LanguageSwitcher;
